<div
    *transloco="let t"
    [class]="'bazis-control ' + cssClassSizeControl"
    [ngClass]="{
        'bazis-control--focused': isFocused,
        'bazis-control--dirty': ngControl.control.dirty,
        'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': field.disabled,
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
            valueChanges: valueChanges$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <div
            class="bazis-control__field-group"
            [class.bazis-control__field-group--disabled]="field.disabled"
            [class.bazis-control__field-group--focused]="isFocused"
        >
            <bazis-control-field-start
                [isClickable]="isLeftIconClickable"
                [icon]="leftIcon"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipSettings]="tooltipSettings"
                (actionClick)="onLeftIconClick($event)"
            >
            </bazis-control-field-start>

            <div class="bazis-control__field-wrapper">
                <input
                    [type]="showPass ? 'text' : 'password'"
                    class="bazis-control__field"
                    [class.bh-no-padding]="withoutInnerPadding"
                    [placeholder]="placeholder ? placeholder : t(placeholderKey)"
                    (focus)="markAsTouched(); isFocused = true"
                    (blur)="blurField($event)"
                    [autocomplete]="autocomplete"
                    [formControl]="field"
                />
            </div>

            <bazis-control-field-end
                [isClickable]="true"
                [icon]="showPass ? icons.hidePass : icons.showPass"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipSettings]="tooltipSettings"
                [unitText]="unit || t(unitKey)"
                [canEraserShow]="canEraserShow"
                [value]="ngControl.control.value"
                (actionClick)="showPass = !showPass"
                (erased)="onClear($event)"
            >
            </bazis-control-field-end>
        </div>

        <div class="bazis-control__error">
            <bazis-form-error
                [validationErrorMessages]="validationErrorMessages"
                [formControl]="ngControl.control"
            ></bazis-form-error>

            <!-- для ошибок родительского контрола
            (пример использоавния в input-text-array, предполагается сюда "вложить" bazis-form-error) -->
            <ng-content></ng-content>
        </div>

        @if (ngControl.control.valid && ngControl.control.value) {
            <div class="bazis-list">
                @let strengthLevelData = strengthLevel$ | async;
                @if (strengthLevelData) {
                    <div class="bazis-item bh-margin-vertical-2x">
                        <div class="tms-password-indicator">
                            <div [color]="strengthLevelData.color"></div>
                            <div
                                [color]="
                                    strengthLevelData.id === 'low' ? '' : strengthLevelData.color
                                "
                            ></div>
                            <div
                                [color]="
                                    strengthLevelData.id === 'extremelyHigh' ||
                                    strengthLevelData.id === 'high'
                                        ? strengthLevelData.color
                                        : ''
                                "
                            ></div>
                            <div
                                [color]="
                                    strengthLevelData.id === 'extremelyHigh'
                                        ? strengthLevelData.color
                                        : ''
                                "
                            ></div>
                        </div>
                    </div>

                    <div class="bazis-item">
                        <span class="bazis-text_secondary bh-flex bh-align-items-center">
                            <bazis-icon
                                [name]="strengthLevelData.color === 'danger' ? 'cross' : 'check'"
                                size="compact"
                                class="bh-margin-end-1x"
                            >
                            </bazis-icon>
                            {{ t('form.password.strength.level.title') }}:&nbsp;
                            <span
                                [color]="
                                    strengthLevelData.id === 'extremelyHigh'
                                        ? 'success'
                                        : strengthLevelData.color
                                "
                                >{{
                                    t('form.password.strength.level.' + strengthLevelData.id)
                                }}</span
                            >
                        </span>
                    </div>
                }

                @let strengthCriterias = strengthCriteriasToDisplay$ | async;

                @if (strengthCriterias$) {
                    @for (strengthCriteria of strengthCriterias; track strengthCriteria.id) {
                        <div class="bazis-item">
                            <span
                                [color]="strengthCriteria.isValid ? 'success' : ''"
                                class="bazis-text_secondary bh-flex bh-align-items-center"
                            >
                                <bazis-icon
                                    [name]="strengthCriteria.isValid ? 'check' : 'cross'"
                                    size="compact"
                                    class="bh-margin-end-1x"
                                ></bazis-icon>
                                {{
                                    t(
                                        'form.password.strength.criteria.' +
                                            (strengthCriteria.titleKey || strengthCriteria.id),
                                        strengthCriteria.titleParam || ''
                                    )
                                }}
                            </span>
                        </div>
                    }
                }
            </div>
        }

        @if (noteKey) {
            <div class="bazis-control__note">
                {{ t(noteKey, noteParams) }}
            </div>
        }
    </ng-container>
</div>
